import { Component, Prop, Vue } from 'vue-property-decorator';
import { MiFormField } from '@/components/MiForm/MiForm';
import { RangeFormatter } from '@/support/Date';
import { ValidationRules, Rules } from '@/support/ValidationRules';
import { Settings } from 'luxon';

@Component<Rangepicker>({})
export default class Rangepicker extends Vue {
  @Prop()
  protected field!: MiFormField;

  protected date: RangeFormatter = new RangeFormatter();

  protected dateMenuTable = false;

  protected validationRules: Rules = ValidationRules();

  protected mounted() {
    Settings.defaultLocale = 'nl';

    if (! this.field) { return; }
    this.createDateFormatter();
  }

  protected createDateFormatter() {
    if (this.date && this.field.value) {
      this.date.selectedDates = this.field.value as string[];
    }
  }

  /**
   * Set field rules
   *
   * @protected
   * @param {MiFormField} field
   * @returns { void }
   * @memberof MiForm
   */
  protected fieldRules(field: MiFormField) {
    if (! field.rules) {
      return [];
    }

    const rules: Function[] = [];
    field.rules.forEach((rule: string) => {
      rules.push(this.validationRules[rule]);
    });

    return rules;
  }

  protected handleDateClear(field: MiFormField) {
    field.value = '';
    this.$emit('handleDateClear', field);
  }

  protected handleFieldChanged(field: MiFormField) {
    field.value = this.date ? this.date.selectedDates : '';
    this.$emit('handleFieldChanged', field);
  }

  protected get rangeText() {
    return this.date.formattedDates.join(' - ');
  }
}
